module.exports = __webpack_public_path__ + "static/img/b1-5-2.1838c93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b1-5-2.png
// module id = JxIV
// module chunks = 1